import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';

import olawee from "../../../media/img/home/ProductoOlawee.png";
import okapi from "../../../media/img/home/ProductoOkapi.png";
import "./productShowcase.scss"

// Swiper
import "swiper/css";
import "swiper/css/navigation";

const ProductShowcase = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    const products = [
        {
            id: 1,
            logo: okapi,
            title: "OKAPI",
            description: t("home.productShowcase.okapiDesc")
        },
        {
            id: 2,
            logo: olawee,
            title: "OLAWEE",
            description: t("home.productShowcase.olaweeDesc")
        }
    ];

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });


        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div>
            <section className='section__products'>
                <div className='products__header'>
                    <h1 className='content__title-backgroundDark'>{t("home.productShowcase.title")}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <p className='content__text-title-backgroundDark'>{t("home.productShowcase.subtitle")}</p>
                </div>
                <div className="products-container">
                    {products.map((product) => (
                        <div className="products-card" key={product.id}>
                            <div className='products-card__icon' >
                                <img className='products-card__image'
                                    src={product.logo}
                                    alt={product.title}
                                />
                            </div>
                            <div className="products-card__content">
                                <h3 className="products-card__title">{product.title}</h3>
                                <p className="products-card__description">{product.description}</p>
                            </div>
                        </div>
                    ))}

                </div>

                <div className="services-info__block services-info__block--link">
                    <a href="/productos/services" className="services-info__link">
                        {t("home.productShowcase.knowMore")}
                    </a>
                </div>
            </section>
        </div>
    )
}

export default ProductShowcase;